// Global
import { tv } from 'tailwind-variants';

export const tailwindVariantsBrandCard = tv({
  defaultVariants: {
    grid: '6column',
  },
  slots: {
    componentBG: ['bg-components-tab-bg-2'],
    base: [
      'md:py-themes-general-surface-spacing-large-padding-y',
      'md:px-themes-general-surface-spacing-large-padding-x',
      'px-themes-general-surface-spacing-small-padding-x',
      'py-components-media-gallery-spacing-small-padding-y',
    ],
    contentWrapper: ['flex', 'flex-col', 'gap-spacing-spacing-7'],
    titleAndDescriptionWrapperOuter: [
      'w-full',
      'flex',
      'flex-col',
      'justify-between',
      'items-start',
      'self-stretch',
      'md:flex-row',
      'gap-spacing-spacing-7',
      'md:gap-spacing-spacing-0',
    ],
    titleAndDescriptionWrapperInner: ['flex', 'flex-col', 'flex-1'],
    titleText: [
      'font-header-large-medium',
      'leading-header-large-medium',
      'text-header-large-medium',
      'text-themes-text-color-dark',
    ],
    descriptionText: [
      'font-bodySans-small',
      'leading-bodySans-small',
      'text-bodySans-small',
      'md:font-bodySans-medium',
      'md:leading-bodySans-medium',
      'md:text-bodySans-medium',
      'text-components-article-card-listing-color-default-copy',
      'mb-themes-general-surface-spacing-small-body-margin-bottom',
      'md:mb-0',
    ],
    brandContainer: ['brand-Container', 'flex', 'flex-col', 'gap-spacing-spacing-7', 'md:flex-row'],
    brandTitle: [
      'font-bodySans-medium-semibold',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'rounded-themes-spacing-radius-large-button',
      'text-components-button-group-color-button-fg-default',
      'cursor-pointer',
      'text-nowrap',
      'md:text-wrap',
      'content-center',
      'min-h-11',
      'hover:bg-components-button-group-color-button-bg-hover',
      'pl-spacing-spacing-4',
      'px-components-dropdown-item-padding-x',
      'py-components-dropdown-item-padding-y',
    ],
    brandContainerLeftWrapper: [
      'brand-information-left',
      'md:max-w-52',
      'md:min-w-52',
      'md:pb-0',
      'pb-1',
      'flex',
      'flex-row',
      'md:flex-col',
      'self-stretch',
      'overflow-x-auto',
      'md:pb-spacing-spacing-0',
      'gap-spacing-spacing-1',
    ],
    brandContainerRightWrapper: [
      'brand-information-right',
      'justify-items-center',
      'md:justify-items-start',
      'self-center',
      'md:self-baseline',
      'grid',
      'gap-x-components-media-gallery-large-container-grid-gap-x',
      'gap-y-components-media-gallery-large-container-grid-gap-y',
    ],
    brandContainerWrapper: ['brandContainerWrapper', 'flex', 'flex-col', 'gap-[40px]'],
    loaderWrapper: [
      'h-64',
      'w-full',
      'content-center',
      'bg-components-pdf-link-card-color-card-bg',
    ],
    searchLoaderAnimation: [
      'animate-spin',
      'block',
      'w-20',
      'h-20',
      'm-auto',
      'bg-components-omnibox-color-loader-icon-fill-default',
      '[clip-path:path("M73.3333_40.0038C73.3333_58.4115_58.411_73.3338_40.0033_73.3338C21.5957_73.3338_6.67334_58.4115_6.67334_40.0038C6.67334_21.5962_21.5957_6.67383_40.0033_6.67383C58.411_6.67383_73.3333_21.5962_73.3333_40.0038ZM13.3393_40.0038C13.3393_54.73_25.2772_66.6678_40.0033_66.6678C54.7295_66.6678_66.6673_54.73_66.6673_40.0038C66.6673_25.2777_54.7295_13.3398_40.0033_13.3398C25.2772_13.3398_13.3393_25.2777_13.3393_40.0038Z")]',
    ],
    cardImageWrapper: [
      'justify-items-center',
      'md:justify-items-start',
      'content-center',
      'rounded-themes-spacing-radius-large-card',
      'border',
      'border-themes-radius-large-card',
      'border-color-system-brands-bg',
      'hover:border',
      'hover:border-themes-radius-large-card',
      'hover:border-themes-color-stroke-brand2',
      'cursor-pointer',
      'bg-color-system-brands-bg',
      'hover:bg-color-system-brands-bg-hover',
      'min-h-[7em]',
      'min-w-[7em]',
    ],
    archiveSection: ['flex', 'flex-col', 'gap-[24px]'],
    textLink: ['[&>a]:block'],
    brandCardTitle: [
      'text-header-large-xSmall',
      'font-header-large-xSmall',
      'leading-header-large-xSmall',
    ],
    brandCardDescription: [
      'text-bodySans-medium',
      'font-bodySans-medium',
      'leading-bodySans-medium',
      'text-components-generic-card-listing-color-copy',
    ],
    titleArchives: [
      'text-header-large-xSmall',
      'font-header-large-xSmall',
      'leading-header-large-xSmall',
      'md:text-header-large-xSmall',
      'md:font-header-large-xSmall',
      'md:leading-header-large-xSmall',
    ],
    descriptionArchives: [
      'text-bodySans-medium',
      'font-bodySans-medium',
      'leading-bodySans-medium',
      'md:text-bodySans-medium',
      'md:font-bodySans-medium',
      'md:leading-bodySans-medium',
    ],
    archiveCTA: ['[&>a]:!w-full', '[&>a]:sm:!w-fit'],
    gradientMobile: ['absolute', 'w-3', 'h-12', 'right-5', 'max-md:block', 'hidden'],
    // Filter Tab component
    filterTabcomponentBG: ['bg-components-product-results-list-with-search-color-bg'],
    filterTabcontentWrapper: ['flex', 'flex-col'],
    filterTabBrandTitle: [
      'font-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'text-bodySans-medium-semibold',
      'text-components-button-group-color-button-fg-default',
      'text-nowrap',
      'cursor-pointer',
      'rounded-themes-spacing-radius-large-button',
      'hover:bg-components-button-group-color-button-bg-hover',
      'min-h-12',
      'content-center',
      'py-components-button-spacing-large-default-padding-y',
      'px-components-button-spacing-large-default-padding-x',
    ],
    filterTabButtons: [
      'flex',
      'flex-row',
      'overflow-x-auto',
      'md:gap-x-components-button-group-spacing-space-between',
      'pt-spacing-spacing-5',
      'pb-components-product-results-list-with-search-spacing-large-ruleline-margin-top',
    ],
    filterTabContainer: [
      'filterTab-Container',
      'flex',
      'flex-col',
      'md:flex-row',
      'gap-spacing-spacing-7',
      'pt-spacing-spacing-7',
      'md:pt-themes-general-surface-spacing-large-margin-bottom',
    ],
    filterTabContainerWrapper: [
      'filterTab-Container-Wrapper',
      'grid',
      'grid-rows-1',
      'md:grid-cols-4',
      'w-full',
      'pb-themes-general-surface-spacing-large-margin-bottom',
      'gap-x-components-media-gallery-large-container-grid-gap-x',
      'gap-y-components-media-gallery-large-container-grid-gap-y',
    ],
    svgClassLarge: [
      'block',
      'lg:hidden',
      '[&>*]:h-full',
      '[&>*]:w-full',
      'fill-colors-accent-1-400',
    ],
    svgClassExtraLarge: [
      'hidden',
      'lg:block',
      '[&>*]:h-full',
      '[&>*]:w-full',
      'fill-colors-accent-1-400',
    ],
    cardWrapper: [
      'flex',
      'flex-col',
      'md:h-auto',
      'cursor-pointer',
      'border',
      'rounded-themes-spacing-radius-large-card',
      'bg-components-product-card-color-content-bg',
      'border-themes-radius-large-card',
      'border-components-tab-bg-2',
      'hover:border-themes-color-stroke-brand2',
      'rounded-tr-themes-spacing-radius-large-card',
      'rounded-tl-themes-spacing-radius-large-card',
      '[&_img]:hover:bg-color-system-brands-bg-hover',
      '[&_h2]:hover:!text-themes-color-text-brand1',
      '[&_h2]:hover:underline',
    ],
    imageTab: [
      'w-full',
      'h-auto',
      '!overflow-hidden',
      'rounded-tr-themes-spacing-radius-large-card',
      'rounded-tl-themes-spacing-radius-large-card',
      'bg-color-system-brands-bg',
    ],
    filterTabContent: [
      'flex',
      'flex-col',
      'gap-components-product-card-spacing-large-title-margin-bottom',
      'px-components-product-card-spacing-large-padding-content-x',
      'py-components-product-card-spacing-large-padding-content-y',
    ],
    cardTitleText: [
      'w-fit',
      'font-header-large-xxSmall',
      'text-header-large-xxSmall',
      'leading-header-large-xxSmall',
      'text-components-product-card-color-title',
    ],
    cardDescriptionText: [
      'font-bodySans-medium',
      'leading-bodySans-medium',
      'text-bodySans-medium',
      'pb-1',
      'line-clamp-2',
      'text-components-product-card-color-description',
    ],
  },
  variants: {
    grid: {
      '5column': {
        brandContainerRightWrapper: ['md:grid-cols-5', 'grid-cols-2'],
      },
      '6column': {
        brandContainerRightWrapper: ['md:grid-cols-6', 'sm:grid-cols-3', 'grid-cols-1'],
      },
    },
  },
});
